'use strict';

window.isIE = !!navigator.userAgent.match(/MSIE/) || !!navigator.userAgent.match(/Trident\/7.0/);  // !! coz .match return null !!(null||false) == false or true

window.app = angular.module('harriApp', []);

window.angularInjector = angular.injector(["ng"]);
window.$http = angularInjector.get("$http");
window.$q = angularInjector.get("$q");
window.$timeout = angularInjector.get("$timeout");
